import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const extractPlaylistId = (url) => {
  if (!url) return null;
  const match = url.match(/playlist\/([a-zA-Z0-9]+)/);
  return match ? match[1] : null;
};

const SpotifySection = () => {
  const { t } = useTranslation();
  const [playlistUrl, setPlaylistUrl] = useState('');

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${BACKEND_URL}/api/settings`);
        setPlaylistUrl(response.data.spotify_playlist_url || '');
      } catch (error) {
        console.error('Error fetching settings for Spotify:', error);
      }
    };
    fetchSettings();
  }, []);

  const playlistId = extractPlaylistId(playlistUrl);
  if (!playlistId) return null;

  return (
    <section
      className="py-16 sm:py-24 bg-[#060606]"
      data-testid="spotify-section"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-8"
        >
          <h2 className="font-display text-4xl sm:text-5xl tracking-tight text-[#F5F0E8] mb-3">
            {t('spotify.title')}
          </h2>
          <p className="font-serif italic text-lg text-[#B9B2A8]">
            {t('spotify.subtitle')}
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          className="rounded-2xl overflow-hidden border border-[#1DB954]/30 shadow-2xl"
        >
          <iframe
            title="Invasion Latina Spotify Playlist"
            src={`https://open.spotify.com/embed/playlist/${playlistId}?utm_source=generator&theme=0`}
            width="100%"
            height="420"
            frameBorder="0"
            allowFullScreen
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
          />
        </motion.div>

        <div className="text-center mt-6">
          <a
            href={playlistUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-sm text-[#1DB954] hover:text-[#2ECC71] transition-colors"
          >
            {t('spotify.open_in_spotify')} →
          </a>
        </div>
      </div>
    </section>
  );
};

export default SpotifySection;
